export default __webpack_public_path__ + "img/tyra.c0c9b518.jpg";